"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ChatDisabledSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M4.70913674,4.02099731 L5.362,4.99892674 L5.03672752,4.99932532 L4.92431496,5.00277525 C4.44538412,5.03810947 4.06305131,5.41115676 4.00706479,5.88073418 L4,6 L3.9992564,10.961443 L4.00305667,11.0794062 C4.03783309,11.5282744 4.37126097,11.8950657 4.77560298,11.9793555 L4.88746517,11.9951889 L6,12.0360772 L5.998,13.565 L8.3481976,12 L10.029,11.9999267 L10.696,12.9999267 L8.651,13 L5.77737049,14.9159565 C5.69523247,14.970721 5.59872084,14.999945 5.5,14.999945 C5.25454011,14.999945 5.05039163,14.8230698 5.00805567,14.5898206 L5,14.499945 L5,13 L4.85073766,12.9945143 C3.86762078,12.9219826 3.08213523,12.1387735 3.00604447,11.1566505 L3,11 L3,6 C3,4.99422154 3.74242134,4.16184488 4.70913674,4.02099731 Z M5.85946839,2.15233734 L5.91602515,2.2226499 L13.9160251,14.2226499 C14.0692014,14.4524142 14.0071144,14.7628489 13.7773501,14.9160251 C13.5731151,15.0521818 13.3051406,15.018254 13.1405316,14.8476627 L13.0839749,14.7773501 L5.08397485,2.7773501 C4.93079862,2.54758575 4.99288556,2.23715108 5.2226499,2.08397485 C5.42688487,1.9478182 5.69485937,1.98174603 5.85946839,2.15233734 Z M13,3.99992674 C14.0543618,3.99992674 14.9181651,4.81587779 14.9945143,5.85073766 L15,6 L15,11 C15,11.7031913 14.6370952,12.3216216 14.0883575,12.678219 L13.533416,11.8462261 C13.7823665,11.6887882 13.9565539,11.4244079 13.9929352,11.1192658 L14,11 L14.0006747,6.03672752 L13.9972247,5.92431496 C13.9618905,5.44538412 13.5888432,5.06305131 13.1192658,5.00706479 L13,5 L8.969,4.99892674 L8.302,3.99992674 L13,3.99992674 Z" })));
};
ChatDisabledSmall.displayName = 'ChatDisabledSmall';
exports.default = ChatDisabledSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ChatDisabledSmall.js.map